export const artist = {
  Artist: 'Artist',
  Composer: 'Composer',
  'Verified Artist': 'Verified Artist',
  Popular: 'Popular',
  Discography: 'Discography',
  'Popular Releases': 'Popular Releases',
  'Show More': 'Show More',
  'Appears on': 'Appears on',
  'Popular Albums': 'Popular Albums',
  Singles: 'Singles',
  Albums: 'Albums',
  'Singles and EPs': 'Singles and EPs',
};
